module.exports = __webpack_public_path__ + "img/112_characters@2x.a057d932.png";